<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#service-page {
        position: absolute;
        right: 1rem;
        top: 6rem;
        background: #FFFFFF;
        width: 100%;
        max-width: 500px;
        border-radius: 0.5rem;
        padding: 0.75rem;
        box-shadow: 0 0 #000000, 0 0 #000000, 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1);

        div.close-block {
            top: 0.5rem;
            right: 0.5rem;
            position: absolute;

            a.close-block-button {
                justify-content: center;
                align-items: center;
                display: inline-flex;
                border-radius: 0.375rem;
                outline: 2px solid transparent;
                outline-offset: 2px;
                color: rgb(156, 163, 175);
                padding: 0.5rem;

                svg {
                    width: 1.5rem;
                    height: 1.5rem;
                }

                &:hover {
                    background-color: rgb(243, 244, 246);
                    color: rgb(107, 114, 128);
                }
            }
        }

        h2.service-title {
            color: #342C0C;
            font-size: 18px;
            line-height: 20px;
            margin-top: 10px;
            margin-left: auto;
            margin-right: auto;
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            text-align: center;
        }

        a.order-service-button {
            display: block;
            height: 50px;
            color: white;
            text-align: center;
            border-radius: 5px;
            font-size: 16px;
            font-weight: 700 !important;
            font-family: 'Raleway', sans-serif;
            background-color: $secondary-color;
            -webkit-appearance: none;
            line-height: 50px;
            margin-bottom: 10px;
            margin-top: 20px;
            transition: color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),box-shadow .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),background-color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            border: none;

            &:hover {
                background-color: #810050;
            }
        }

        button.copy-btn {
            margin-left: 5px;
            outline: none;
            cursor: pointer;
            opacity: .6;
            transition: all .1s ease;

            &:hover {
                transform: translateY(-3px);
                opacity: 1;
            }

            img {
                width: 20px;
            }
        }

        span.service-block-copy {
            position: relative;
            display: inline-block;

            span.tooltip-service-name {
                position: absolute;
                top: 25px;
                left: -35px;
                background: #373737;
                padding: 5px 10px;
                display: flex !important;
                justify-content: center;
                color: #fff;
                font-size: 13px;
                font-weight: normal;
                border-radius: 4px;
                opacity: 0;

                &.appear {
                    animation: appear 1s ease;
                }
            }
        }

        span.location-number {
            display: inline-block;
            color: #8E8E8E;
            font-size: 18px;

            span.location-image-container{
                width: 35px;
                text-align: center;
                display: inline-block;
            }
        }

        label.info-label {
            font-family: 'Raleway', sans-serif;
            text-transform: uppercase;
            font-weight: bold;
            color: black;
            margin-top: 5px;
            margin-bottom: 5px;
        }

        div.info-container {
            color: #666666;
            font-size: 16px;
            line-height: 20px;
            font-family: 'Raleway', sans-serif;
            margin-bottom: 5px;

            span {
                display: block;
            }
        }

        table.info-container-table {
            margin-bottom: 5px;
        }

        a.service-link {
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            color: $secondary-color;
            font-size: 16px;
        }

        li.phone-list {
            list-style: none;
        }

        a.phone-number {
            font-family: 'Raleway', sans-serif;
            font-weight: bold;
            color: $secondary-color;
            font-size: 16px;

            &:not(:first-child) {
                margin-left: 10px;
            }
        }

        span.service-info-text {
            display: block;
            text-align: center;
            margin-top: 3px;
            font-family: 'Raleway', sans-serif;
            font-size: 12px;
            color: #666666;
        }
    }

    @keyframes appear {
        0% {
            opacity: 0;
        }

        20% {
            transform: translateY(10px);
            opacity: 1;
        }

        80% {
            transform: translateY(0px);
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div#service-page {
            position: fixed;
            right: 0px;
            left: 0px;
            top: 0px;
            bottom: 0px;
            z-index: 99999;

            h2.service-title {
                color: #342C0C;
                font-size: 22px;
                line-height: 20px;
                margin-top: 30px;
            }

            div.info-container {
                font-size: 15px;
                line-height: 20px;
            }

            a.service-link {
                font-size: 15px;
            }

            a.phone-number {
                font-size: 15px;
            }
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {

    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }
</style>

<template>
    <div id="service-page">
        <div class="close-block">
            <a v-on:click="leaveService()" class="close-block-button">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </a>
        </div>

        <loader v-show="serviceLoadStatus == 0 || serviceLoadStatus == 1" :width="100" :height="100"></loader>

        <h2 class="service-title" v-if="serviceLoadStatus == 2">{{ service.name }}
            <span class="service-block-copy" v-if="workroom == 60">
                <span class="tooltip-service-name">{{ $t('detail.tooltipCopied') }}</span>
                <button class="copy-btn" @click="copyToClipBoard(service.name + ', ' + service.street + ', ' + service.city + ' (tel. ' + formatPhone(service.phone[0]) + ')')">
                    <img src="/img/icons/copy-icon.svg" v-bind:title="$t('detail.buttonCopyAddress')">
                </button>
            </span>
        </h2>

        <div class="grid-x" v-if="serviceLoadStatus == 2 && workroom != 60 && workroom != 860">
            <div class="large-12 medium-12 small-12 cell">
                <router-link :to="{ name: 'orderservice', params: { slug: service.slug } }" class="order-service-button">
                    {{ $t('detail.orderToServiceButton') }}
                </router-link>
            </div>
        </div>

        <div class="grid-x" v-if="serviceLoadStatus == 2 && workroom == 860">
            <div class="large-12 medium-12 small-12 cell">
                <router-link :to="{ name: 'orderinspector', params: { slug: service.slug } }" class="order-service-button">
                    {{ $t('detail.orderReturnWithInspector') }}
                </router-link>
            </div>
        </div>

        <div class="grid-x" v-if="serviceLoadStatus == 2 && workroom == 60">
            <div class="large-12 medium-12 small-12 cell">
                <a :href="navigationMapLink(service.latitude, service.longitude)" target="_blank" class="order-service-button">
                    {{ $t('detail.navigateToServiceButton') }}
                </a>
            </div>
        </div>

        <div class="grid-x" v-if="serviceLoadStatus == 2">
            <div class="large-12 medium-12 small-12 cell">
                <label class="info-label" v-if="workroom == 860">{{ $t('detail.infoAboutParkingArea') }}</label>
                <label class="info-label" v-else>{{ $t('detail.infoAboutService') }}</label>
                <div class="info-container">
                    <span>{{ service.street }}</span>
                    <span>{{ service.city }}</span>
                    <span>{{ service.distance }} km</span>
                </div>

                <label class="info-label" v-if="service.working_hours || service.working_hours_sat || service.working_hours_sun">{{ $t('detail.openingHours') }}</label>
                <div class="info-container" v-if="service.working_hours || service.working_hours_sat || service.working_hours_sun">
                    <table class="info-container-table" cellpadding="0" cellspacing="0" border="0">
                        <tbody>
                            <tr v-if="service.working_hours">
                                <td>{{ $t('detail.openingHoursWeek') }}</td>
                                <td>{{ service.working_hours }}</td>
                            </tr>

                            <tr v-if="service.working_hours_sat">
                                <td>{{ $t('detail.openingHoursSaturday') }}</td>
                                <td>{{ service.working_hours_sat }}</td>
                            </tr>

                            <tr v-if="service.working_hours_sun">
                                <td>{{ $t('detail.openingHoursSunday') }}</td>
                                <td>{{ service.working_hours_sun }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <span class="service-info-text" v-if="service.working_hours || service.working_hours_sat || service.working_hours_sun">
                    {{ $t('detail.openingHoursNote') }}
                </span>

                <label v-if="workroom == 60" class="info-label">{{ $t('detail.contact') }}</label>
                <div v-if="workroom == 60" class="info-container">
                    <span>{{ $t('detail.contactEmail') }}: <a class="service-link" target="_blank" v-bind:href="'mailto:' + service.email">{{ service.email }}</a></span>
                    <span>{{ $t('detail.contactPhone') }}:
                        <!--<li class="phone-list" v-for="phone in service.phone">
                            <a class="phone-number" v-bind:href="'tel:' + phone.trim()">{{ formatPhone(phone) }}</a>
                        </li>-->
                        <a class="phone-number" v-for="phone in service.phone" v-bind:href="'tel:' + phone.trim()">{{ formatPhone(phone) }}</a>
                    </span>
                </div>
            </div>
        </div>

        <div class="grid-x" v-if="serviceLoadStatus == 2 && (service.pickup_included || serviceSlotDefinition.pickup_included || service.replacement_car_included || service.replacement_car_included == false || serviceSlotDefinition.replacement_car_included || service.car_wash_included || serviceSlotDefinition.car_wash_included) && workroom != 860">
            <div class="large-12 medium-12 small-12 cell">
                <label class="info-label">{{ $t('detail.additionalServices') }}</label>

                <loader v-if="slotDefinition == true" v-show="serviceSlotDefinitionLoadStatus == 0 || serviceSlotDefinitionLoadStatus == 1" :width="100" :height="100"></loader>

                <div class="extended-services-block">
                    <div class="extended-services" v-if="service.pickup_included == true && slotDefinition == false">
                        <img v-bind:src="'/img/icons/pick-up.svg'" class="extended-services-icon" />
                        <span class="extended-services-name">{{ $t('detail.additionalServicesPickUp') }}</span>
                    </div>

                    <div class="extended-services" v-if="serviceSlotDefinition.pickup_included == true && slotDefinition == true">
                        <img v-bind:src="'/img/icons/pick-up.svg'" class="extended-services-icon" />
                        <span class="extended-services-name" v-if="serviceSlotDefinition.pickup_cond == 1">{{ $t('detail.additionalServicesPickUp') }}<br />{{ $t('detail.additionalServicesFree') }}*</span>
                        <span class="extended-services-name" v-if="serviceSlotDefinition.pickup_cond == 0">{{ $t('detail.additionalServicesPickUp') }}</span>
                    </div>

                    <div class="extended-services" v-if="service.replacement_car_included == true && slotDefinition == false">
                        <img v-bind:src="'/img/icons/replacement-car.svg'" class="extended-services-icon" />
                        <span class="extended-services-name">{{ $t('detail.additionalServicesReplacementVehicle') }}</span>
                        <span class="extended-services-name-sub" v-if="extendedServicesDeniedReplacementVehicleCodes.includes(this.replCarEntitlementCode)">({{ $t('detail.additionalServicesNotAgreed') }})</span>
                    </div>

                    <div class="extended-services" v-if="service.replacement_car_included == false && slotDefinition == false">
                        <img v-bind:src="'/img/icons/replacement-car.svg'" class="extended-services-icon" />
                        <span class="extended-services-name">{{ $t('detail.additionalServicesReplacementVehicle') }}</span>
                        <span class="extended-services-name-sub" v-if="extendedServicesDeniedReplacementVehicleCodes.includes(this.replCarEntitlementCode)">({{ $t('detail.additionalServicesNotAgreed') }})</span>
                    </div>

                    <div class="extended-services" v-if="serviceSlotDefinition.replacement_car_included == true && slotDefinition == true">
                        <img v-bind:src="'/img/icons/replacement-car.svg'" class="extended-services-icon" />
                        <span class="extended-services-name" v-if="serviceSlotDefinition.replacement_car_cond == 1">{{ $t('detail.additionalServicesReplacementVehicle') }} {{ $t('detail.additionalServicesFree') }}**</span>
                        <span class="extended-services-name" v-if="serviceSlotDefinition.replacement_car_cond == 0">{{ $t('detail.additionalServicesReplacementVehicle') }}</span>
                        <span class="extended-services-name-sub" v-if="extendedServicesDeniedReplacementVehicleCodes.includes(this.replCarEntitlementCode)">({{ $t('detail.additionalServicesNotAgreed') }})</span>
                    </div>

                    <!--
                    <div class="extended-services" v-if="service.car_wash_included == true && slotDefinition == false">
                        <img v-bind:src="'/img/icons/car-wash.svg'" class="extended-services-icon" />
                        <span class="extended-services-name" v-if="service.car_wash_cond == 1">{{ $t('detail.additionalServicesCarWash') }} {{ $t('detail.additionalServicesFree') }}***</span>
                        <span class="extended-services-name" v-if="service.car_wash_cond == 0">{{ $t('detail.additionalServicesCarWash') }}</span>
                    </div>

                    <div class="extended-services" v-if="serviceSlotDefinition.car_wash_included == true && slotDefinition == true">
                        <img v-bind:src="'/img/icons/car-wash.svg'" class="extended-services-icon" />
                        <span class="extended-services-name" v-if="serviceSlotDefinition.car_wash_cond == 1">{{ $t('detail.additionalServicesCarWash') }} {{ $t('detail.additionalServicesFree') }}***</span>
                        <span class="extended-services-name" v-if="serviceSlotDefinition.car_wash_cond == 0">{{ $t('detail.additionalServicesCarWash') }}</span>
                    </div>
                    -->
                </div>

                <span class="service-info-text" v-if="(slotDefinition == false) || (slotDefinition == true && serviceSlotDefinitionLoadStatus == 2)">
                    {{ $t('detail.additionalServicesChargeNote') }}
                </span>

                <span class="service-info-text" v-if="serviceSlotDefinition.pickup_included == true && slotDefinition == true && serviceSlotDefinition.pickup_cond == 1">
                    * {{ $t('detail.additionalServicesPickupNote') }}
                </span>

                <span class="service-info-text" v-if="serviceSlotDefinition.replacement_car_included == true && slotDefinition == true && serviceSlotDefinition.replacement_car_cond == 1">
                    ** {{ $t('detail.additionalServicesReplacementVehicleNote') }}
                </span>

                <!--
                <span class="service-info-text" v-if="(service.car_wash_included == true && slotDefinition == false && service.car_wash_cond == 1) || (serviceSlotDefinition.car_wash_included == true && slotDefinition == true && serviceSlotDefinition.car_wash_cond == 1)">
                    *** {{ $t('detail.additionalServicesCarWashNote') }}
                </span>
                -->
            </div>
        </div>

        <div class="grid-x" v-if="serviceLoadStatus == 2 && (app_env == 'local' || app_env == 'development') && (service.pickup_note || service.replacement_car_note || service.car_wash_note) && workroom != 860">
            <div class="large-12 medium-12 small-12 cell">
                <hr />
                <span class="service-info-text">{{ service.pickup_note }}</span>
                <span class="service-info-text">{{ service.replacement_car_note }}</span>
                <!--<span class="service-info-text">{{ service.car_wash_note }}</span>-->
            </div>
        </div>

    </div>
</template>

<script>
    import { EventBus } from '../event-bus.js';
    import Loader from "../components/global/Loader";
    import Geocode from "../api/geocode";
    import {ROAST_CONFIG} from "../config";

    export default {
        components: {
            Loader
        },

        data: function () {
            return {
                slotDefinition: false,
                extendedServicesDeniedReplacementVehicleCodes: ['Z', 'N'],
                app_env: ROAST_CONFIG.APP_ENV,
            }
        },

        created() {
            this.$store.dispatch('toggleShowFilters', { showFilters : false });

            this.$store.dispatch('changeServicesView', 'map');

            if (this.clientLocation) {
                this.loadService();
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.setClientLocation(position);
                    }, err => {
                        console.log('User denied Geolocation');
                        this.$router.push({ name: 'services' });
                    }, {
                        enableHighAccuracy: true,
                        timeout: 60000
                    });
                }
            }
        },

        watch: {
            '$route.params.slug': function() {
                this.$store.dispatch('loadService', {
                    slug: this.$route.params.slug,
                    distance: this.distance,
                    workroom: this.workroom,
                    makeId: this.makeId,
                    licensePlate: this.licensePlate,
                    latitude: this.clientLocation.latitude,
                    longitude: this.clientLocation.longitude
                });
            },

            'serviceLoadStatus': function() {
                if (this.serviceLoadStatus == 2) {
                    this.loadServiceSlotDefinition();

                    EventBus.$emit('location-selected', {
                        lat: parseFloat(this.service.latitude),
                        lng: parseFloat(this.service.longitude)
                    });
                }

                if (this.serviceLoadStatus == 3) {
                    this.$store.dispatch('flashMessageShow', {
                        type: 'error',
                        message: this.$t('detail.errorMessageNotFound')
                    }, {
                        root: true
                    });

                    this.$router.push({ name: 'services' });
                }
            }
        },

        computed: {
            clientLocation() {
                return this.$store.getters.getClientLocation;
            },

            licensePlate() {
                return this.$store.getters.getLicensePlate;
            },

            workroom() {
                return this.$store.getters.getWorkroom;
            },

            makeId() {
                return this.$store.getters.getMakeId;
            },

            distance() {
                return this.$store.getters.getDistanceFilter;
            },

            serviceLoadStatus() {
                return this.$store.getters.getServiceLoadStatus;
            },

            service() {
                return this.$store.getters.getService;
            },

            serviceSlotDefinition() {
                return this.$store.getters.getServiceSlotDefnition;
            },

            serviceSlotDefinitionLoadStatus() {
                return this.$store.getters.getServiceSlotDefnitionLoadStatus;
            },

            replCarEntitlementCode() {
                return this.$store.getters.getReplCarEntitlementCode;
            }
        },

        methods: {
            setClientLocation(position) {
                Geocode.getCountryCodeFromPosition(position)
                    .then((response) => {
                        if (response != 'CZ') {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: 50.08804, longitude: 14.42076 } })
                        } else {
                            this.$store.commit('setClientCurrentLocation', { location: { latitude: position.coords.latitude, longitude: position.coords.longitude } })
                        }

                        this.loadService();
                    })
                    .catch((error) => {
                        console.log(error)
                    });
            },

            loadService() {
                this.$store.dispatch('loadService', {
                    slug: this.$route.params.slug,
                    distance: this.distance,
                    workroom: this.workroom,
                    makeId: this.makeId,
                    licensePlate: this.licensePlate,
                    latitude: this.clientLocation.latitude,
                    longitude: this.clientLocation.longitude
                });
            },

            loadServiceSlotDefinition() {
                this.$store.commit('setServiceSlotDefinition', {});

                if (this.service.maintenance_slot && !this.makeId) {
                    this.$store.dispatch('loadServiceSlotDefinition', {
                        workroom_id: this.service.workroom_id
                    });

                    this.slotDefinition = true;
                }
            },

            leaveService() {
                this.$router.push({ name: 'services' });
            },

            formatPhone(value) {
                return value.trim().replace(/(\d{3})(\d{3})(\d{3})/,"$1 $2 $3");
            },

            copyToClipBoard(text) {
                $('.tooltip-service-name').addClass('appear').delay(1000).queue(function() {
                    $('.tooltip-service-name').removeClass('appear');
                    $('.tooltip-service-name').dequeue();
                });

                navigator.clipboard.writeText(text);
            },

            navigationMapLink(latitude, longitude) {
                if ((navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPod") != -1) || (navigator.platform.indexOf("iPad") != -1)) {
                    return 'http://maps.apple.com/maps?saddr=' + this.clientLocation.latitude + ',' + this.clientLocation.longitude + '&daddr='+ latitude + ',' + longitude;
                } else {
                    return 'https://www.google.com/maps/dir/' + this.clientLocation.latitude + ',' + this.clientLocation.longitude + '/' + latitude + ',' + longitude;
                }
            },
        }
    }
</script>
